<script setup>
import { computed } from "vue";
import { helpers } from '@shop/frontend/web/js/helpers';
import IModal from '@components/IModal/IModal.vue';
import { Modal } from '@shop/frontend/web/js/components/Modal';
import api from '@shop/frontend/web/js/api';


const props = defineProps({
    bulkBuyTeacherParams: {
        type: Object,
        required: true,
    },
    order: {
        type: Object,
        required: true,
    }
})

const emit = defineEmits(["closeCollectivePurchaseModal"])

const succesCollectivePurchaseModal = new Modal({
  className: 'i-modal_collective-purchase-success',
});

const isModalShow = defineModel();

const soldCorrectForm = computed(() => {
    return helpers.wordEnding(props.bulkBuyTeacherParams.isBulkAccompanyingPaymentKind, ['билет', 'билета', 'билетов'])
})

const ticketCorrectForm = computed(() => {
    return helpers.wordEnding(props.bulkBuyTeacherParams.serviceCountInOrder, ["выкуплен", "выкуплено", "выкуплено"])
})


const makeBulkBuyTeacher = async () => {
    try {
        await api.bulkBuyTeacher.makeOrderBulk(props.order.id, props.order.cases[0].id);
        $(location).prop('href', `${window.location.origin}/collective-purchase`);
      } catch (e) {
        console.error(e);
        emit('closeCollectivePurchaseModal')
        succesCollectivePurchaseModal.show(JSON.parse(e).error);
        succesCollectivePurchaseModal.on('hide', () => window.location.reload());
      }
}
</script>

<template>
    <IModal
        v-model="isModalShow"
        class="collective-purchase-modal"
        btn-primary="Продолжить"
        btn-secondary="Отмена"
        @ok="makeBulkBuyTeacher"
        @cancel="emit('closeCollectivePurchaseModal')"
    >
    <template #header>
        <h3 class="collective-purchase-modal__heading">Вы уверены, что в корзине достаточное количество мест для выкупа?</h3>
    </template>
    <template #body>
        <p class="collective-purchase-modal__text">Рекомендуем проверить выбранные места до сформирования ссылки. Если все указано верно, нажмите на кнопку «Продолжить». После этого Вы окажитесь в разделе «Выкуп мест», в котором сможете скопировать и отправить ссылку для покупки каждого места отдельным покупателям.</p>
        <div class="collective-purchase-modal__information">
            <svg class="collective-purchase-modal__information-svg" height="20" width="20">
                <use xlink:href="#information"></use>
            </svg>
            <p class="collective-purchase-modal__information-text">
                Вы cможете выбрать место из списка для сопровождающего лица, как только будет {{ soldCorrectForm }} хотя бы {{bulkBuyTeacherParams.isBulkAccompanyingPaymentKind}} {{ ticketCorrectForm }}. Для этого нажмите на звездочку, далее «Выкупить» и перейдите к оплате.
            </p>
        </div>
    </template>
    </IModal>
</template>

<style>
@import './collective-purchase-modal.scss'

</style>